import { computed, ref, Ref } from '@vue/composition-api';

interface PageProgress {
	setProgress(valueRef: Ref<number>): void;
	progress: Ref<number>;
}

const pageProgress = (initialValue: number): PageProgress => {
	const innerProgress = ref(ref(initialValue));
	const setProgress = (valueRef: Ref<number>) => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		innerProgress.value = valueRef;
	};
	return {
		setProgress,
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		progress: computed(() => innerProgress.value.value),
	};
};

export const PageProgress = pageProgress(0);
